module.exports = __webpack_public_path__ + "img/5.e7f4b180.jpg";